<template>
    <v-card flat class="sub-site-wrapper">
        <div class="chart-component-wrapper">
            <div class="chart-controls">
                <v-btn-toggle variant="outlined" rounded="lg" v-model="chartType">
                    <v-btn value="bar">Bar</v-btn>
                    <v-btn value="line">Line</v-btn>
                    <v-btn value="area">Area</v-btn>
                    <v-btn value="pie">Pie</v-btn>
                </v-btn-toggle>
            </div>
            <div class="charts-wrapper">
                <apexchart v-if="!loading" :key="chartType" :type="chartType" height="400" :options="chartOptions"
                    :series="chartSeries">
                </apexchart>
                <p v-else>Loading...</p>
            </div>
        </div>
    </v-card>
</template>

<script>

import { mapState } from 'vuex';
import VueApexCharts from 'vue3-apexcharts';

export default ({

    components: {
        apexchart: VueApexCharts
    },
    data() {
        return {
            chartType: 'bar'  // Default chart type
        };
    },
    computed: {
        ...mapState('statistics', ['agencyStats', 'loading', 'statisticsAge']),
        chartSeries() {
            if (!this.agencyStats || !this.agencyStats.agenciesPerActiveCustomers) return [];
            const agenciesPerActiveCustomers = this.agencyStats.agenciesPerActiveCustomers;
            const data = Object.values(agenciesPerActiveCustomers);
            // Handle series format for pie chart separately
            return this.chartType === 'pie'
                ? data
                : [{
                    name: 'Count',
                    data: data
                }];
        },
        chartOptions() {
            if (!this.agencyStats || !this.agencyStats.agenciesPerActiveCustomers) return {};
            const agenciesPerActiveCustomers = this.agencyStats.agenciesPerActiveCustomers;
            const categories = Object.keys(agenciesPerActiveCustomers);
            return {
                chart: {
                    type: this.chartType  // Use dynamic chart type
                },
                colors: this.chartType === 'pie' ? ['#783597', '#FF5733', '#C70039', '#900C3F', '#581845', '#FFC300', '#DAF7A6', '#FF5733', '#C70039', '#900C3F', '#581845', '#56BAEC', '#B6D7F2', '#8A2BE2', '#7FFF00', '#D2691E'] : ['#783597'],
                xaxis: this.chartType !== 'pie' ? {
                    categories: categories
                } : undefined,
                labels: this.chartType === 'pie' ? categories : [],
                plotOptions: {
                    bar: {
                        horizontal: false,
                    }
                },
                dataLabels: {
                    enabled: true, // Enable data labels
                    formatter: function (val) {
                        return val.toFixed(0); // Format the value to a whole number
                    }
                },
                title: {
                    text: 'Tatsächlich verwendete Slots pro Agentur',
                    align: 'center'
                }
            };
        }
    }
});
</script>

<style scoped>
.chart-controls {
    display: flex;
    justify-content: center;
    margin: 20px auto;
}

.chart-component-wrapper {
    background-color: white;
    margin: 12px 0;
    padding: 12px;
    border-radius: 12px;
}
</style>